import { LocalStorageKeys, URL } from 'utils/constants';

export const onAuthLogout = () => {
  localStorage.removeItem(LocalStorageKeys.public_token);
  window.location.pathname = URL.LOGIN;
};
